import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import i18n from "../config/i18n";
import { selectCurrentLanguage } from "../redux/selectors/languageSelector";
import { AppDispatch } from "../redux/store/store";

interface LanguageProviderProps {
  children: React.ReactNode;
}

const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
  const dispatch = useDispatch<AppDispatch>();
  const currentLanguage = useSelector(selectCurrentLanguage);

  // Subscribe to Redux language changes and update i18next
  useEffect(() => {
    if (i18n.language !== currentLanguage) {
      i18n.changeLanguage(currentLanguage);
    }
  }, [currentLanguage]);

  // Initialize i18next on mount
  useEffect(() => {
    if (i18n.language !== currentLanguage && currentLanguage) {
      i18n.changeLanguage(currentLanguage);
    }
  }, []);

  return <>{children}</>;
};

export default LanguageProvider;
